import { render, staticRenderFns } from "./TypeSwitchWarningModal.vue?vue&type=template&id=3f026550&scoped=true&lang=pug&"
import script from "./TypeSwitchWarningModal.vue?vue&type=script&lang=js&"
export * from "./TypeSwitchWarningModal.vue?vue&type=script&lang=js&"
import style0 from "./TypeSwitchWarningModal.vue?vue&type=style&index=0&id=3f026550&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f026550",
  null
  
)

export default component.exports